require('jquery-mousewheel');
require('malihu-custom-scrollbar-plugin');

export default () => {
  $(".js-scroll").mCustomScrollbar();
  if ($(window).width() > 1200) {
    $(".js-basket-scroll").mCustomScrollbar();
  }
}



// WEBPACK FOOTER //
// app/scripts/components/scroll.js